/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { WorkLocationTypeCodes } from '@Enum/index';
import * as Yup from 'yup';
import { date } from 'yup';
import dayjs from 'dayjs';
import { AttendanceRequestCodes } from './enum/AttendanceRequestTypeCodes.enum';

const companySchema = Yup.object({
  taReqToCompID: Yup.number().test(
    'deptProj-test',
    'Kindly select a Company',
    (value, context) => {
      if (
        context.parent.leaveTypeID !== AttendanceRequestCodes.LATE_PUNCH &&
        context.parent.leaveTypeID !== AttendanceRequestCodes.NO_PUNCH
      ) {
        return value !== undefined || value !== null;
      }
      return true;
    }
  ),
});

const locationSchema = Yup.object({
  wlId: Yup.number().required('Kindly select a Location'),
});

const deptProjSchema = Yup.object({
  deptProjID: Yup.number().test(
    'deptProj-test',
    'Kindly select a Department or Project',
    (value, context) => {
      if (
        context.parent.leaveTypeID !== AttendanceRequestCodes.LATE_PUNCH &&
        context.parent.leaveTypeID !== AttendanceRequestCodes.NO_PUNCH
      ) {
        return value !== undefined || value !== null;
      }
      return true;
    }
  ),
});

const startDateSchema = Yup.object({
  startDate: date()
    .test(
      'startDate-rule-1',
      'You can only place request for last 30 days!',
      (value, context) => {
        if (
          context.parent.wlId === WorkLocationTypeCodes.PROJECT &&
          dayjs(value).isBefore(dayjs().startOf('day'))
        ) {
          return (
            Math.abs(dayjs(value).diff(dayjs().startOf('day'), 'days')) < 30
          );
        }
        return true;
      }
    )
    .test('startDate-rule-2', 'Kindly Enter the Date!', (value, context) => {
      if (context.parent.leaveTypeID === 1) {
        return true;
      }
      return !!value;
    })
    .test(
      'startDate-rule-3',
      'Date should not be less than 30 days from the current date!',
      (value) => {
        if (dayjs(value).isBefore(dayjs().startOf('day'))) {
          return (
            Math.abs(dayjs(value).diff(dayjs().startOf('day'), 'days')) < 30
          );
        }
        return true;
      }
    ),
});

// fallback for attendance request types not explicitly handled above
// (e.g. types added to the TARequestType dictionary without a matching FE case)
// only Date is mandatory; To Date is optional
const defaultDateRangeSchema = Yup.object({
  startDate: date().required('Kindly Enter the Date!'),
});

const reasonSchema = Yup.object({
  // used as 'reason' field on BE side
  // TODO: add if nessessary later
  // totDays: Yup.string().required(
  //   'Kindly select the Reason from the available list'
  // ),
});

const endDateSchema = Yup.object({
  endDate: date().test(
    'endDate-rule-1',
    'Kindly Enter the To Date!',
    (value, context) => {
      if (
        context.parent.leaveTypeID === AttendanceRequestCodes.TEMPORARY_ACCESS
      ) {
        return !!value;
      }
      return true;
    }
  ),
  // TODO: add if nessesary later
  // .test(
  //   'endDate-rule-2',
  //   'End date can not be less than From date!',
  //   (value, context) => {
  //     const { startDate } = context.parent;

  //     if (!startDate) {
  //       return true;
  //     }

  //     const chosenDateLessThanStartDate =
  //       dayjs(value).startOf('day') < dayjs(startDate).startOf('day');

  //     return !chosenDateLessThanStartDate;
  //   }
  // )
  // .test(
  //   'endDate-rule-3',
  //   'You can not select more than 30 days as per HR direction!',
  //   (value, context) => {
  //     const { startDate } = context.parent;

  //     const diff = dayjs(value).diff(startDate, 'days');

  //     return diff <= 30;
  //   }
  // ),
});

export const getAttendanceReqFormSchema = (
  attendanceType: number | null
): Yup.AnyObjectSchema => {
  const baseSchema = Yup.object({
    leaveTypeID: Yup.number().required('Kindly select a Request Type'),
    currentLocation: Yup.string().required('Kindly Enter the Current Location'),
  });

  if (attendanceType === AttendanceRequestCodes.ADDITIONAL_PERMANENT_ACCESS) {
    return baseSchema
      .concat(companySchema)
      .concat(locationSchema)
      .concat(deptProjSchema);
  }

  if (attendanceType === AttendanceRequestCodes.TEMPORARY_ACCESS) {
    return baseSchema
      .concat(companySchema)
      .concat(locationSchema)
      .concat(deptProjSchema)
      .concat(startDateSchema)
      .concat(endDateSchema);
  }

  if (
    attendanceType === AttendanceRequestCodes.NO_PUNCH ||
    attendanceType === AttendanceRequestCodes.LATE_PUNCH
  ) {
    return baseSchema.concat(startDateSchema).concat(reasonSchema);
  }

  if (attendanceType === AttendanceRequestCodes.TECHNICAL_ISSUE) {
    return baseSchema
      .concat(companySchema)
      .concat(locationSchema)
      .concat(deptProjSchema)
      .concat(startDateSchema)
      .concat(reasonSchema);
  }

  return baseSchema.concat(defaultDateRangeSchema);
};
